import moment from "moment";

const formatToBRL = function (value) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(value);
};

const sanitizeText = function (text) {
  return String(text || "").replace(/"/g, '""');
};

const exportExtratoVisualCSV = function (extrato, filename) {
  if (!filename) filename = "extrato_superbidpay.csv";

  const csvRows = [];
  csvRows.push("Tipo;Data;Descrição;Itens (R$);Valor;Nome;Documento");

  extrato.forEach(function (item) {
    const date = moment(item.creditDate).format("DD/MM/YYYY") || '';
    const valor = (item.type === "D" ? "-" : "") + formatToBRL(item.amount || 0);
    let descricao = item.description || "";
    let documento = "";
    let nomeParte = "";

    if (item.counterpart) {
      documento = (item.counterpart.taxIdentifier && item.counterpart.taxIdentifier.taxId) || "";
      nomeParte = item.counterpart.name || "";
    }

    let details = item.details || null;
    let comment = (!details && item.comment) ? item.comment : null;

    if (details) {
      if (details.event) descricao += " | Evento " + details.event;
      if (details.order) descricao += " | Pedido " + details.order;
      if (details.lots) descricao += " | Lote(s) " + details.lots;
      if (details.customDescription) descricao = details.customDescription;
      if (details.message) descricao += " | " + details.message;

      if (details.customerDescription && !nomeParte) {
        nomeParte = details.customerDescription;
      }
    } else if (comment && typeof comment === "object") {
      if (comment.event) descricao += " | Evento " + comment.event;
      if (comment.order) descricao += " | Pedido " + comment.order;
      if (comment.lots) descricao += " | Lote(s) " + comment.lots;
      if (comment.customDescription) descricao = comment.customDescription;
      if (comment.message) descricao += " | " + comment.message;

      if (comment.customerDescription && !nomeParte) {
        nomeParte = comment.customerDescription;
      }
    } else if (typeof comment === "string") {
      descricao = comment;
    }

    csvRows.push(
      '"MOV";"' +
        sanitizeText(date) + '";"' +
        sanitizeText(descricao) + '";"";"' +
        sanitizeText(valor) + '";"' +
        sanitizeText(nomeParte) + '";"' +
        sanitizeText(documento) + '"'
    );

    const groupData = (details && details.groupData) || (comment && comment.groupData) || [];

    if (Array.isArray(groupData)) {
      groupData.forEach(function (group) {
        const subDescricao = "Lote " + group.lot + " | " + group.desc;
        const subValor = formatToBRL(group.amount || 0);

        csvRows.push(
          '"ITEM";"";"' +
            sanitizeText(subDescricao) + '";"' +
            sanitizeText(subValor) + '";"";"";""'
        );
      });
    }
  });

  const BOM = "\uFEFF";
  const csvContent = BOM + csvRows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default exportExtratoVisualCSV;
